if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.resetButtonState();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || response.message || 'Hubo un problema al agregar el producto.');

            const errorText = `${response.description || response.message || ''}`.toLowerCase();
            const isSoldOutError =
              errorText.includes('sold out') ||
              errorText.includes('agotado') ||
              errorText.includes('out of stock') ||
              errorText.includes('unavailable') ||
              errorText.includes('no disponible') ||
              errorText.includes('not available');

            if (isSoldOutError) {
              this.showSoldOutState();
            } else {
              this.resetButtonState();
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.error = true;
            return;
          }

          this.error = false;
          this.resetButtonState();

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          this.error = true;
          this.handleErrorMessage('Ocurrió un error inesperado. Intenta nuevamente.');
          this.resetButtonState();
          this.submitButton.removeAttribute('aria-disabled');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }

          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    showSoldOutState() {
      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      const mainText = this.submitButton.querySelector('span:not(.sold-out-message)');

      this.submitButton.setAttribute('aria-disabled', true);

      if (mainText) mainText.classList.add('hidden');
      if (soldOutMessage) soldOutMessage.classList.remove('hidden');
    }

    resetButtonState() {
      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      const mainText = this.submitButton.querySelector('span:not(.sold-out-message)');

      if (mainText) mainText.classList.remove('hidden');
      if (soldOutMessage) soldOutMessage.classList.add('hidden');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}